(() => {
  let headerObserver;
  let headerReadyObserver;

  const updateStickyFilterOffset = () => {
    const stickyHeader = document.querySelector('.header--sticky');

    if (!stickyHeader) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const gap = parseFloat(rootStyles.getPropertyValue('--gutter-small')) || 0;
    const offset = Math.ceil(stickyHeader.getBoundingClientRect().height + gap);

    document.querySelectorAll('.facets-sidebar.element--is-sticky').forEach((sidebar) => {
      sidebar.closest('.shopify-section')?.style.setProperty('--collection-filter-sticky-top', `${offset}px`);
    });
  };

  const initialiseStickyFilterOffset = () => {
    const stickyHeader = document.querySelector('.header--sticky');

    if (!stickyHeader) return false;

    headerObserver?.disconnect();
    headerObserver = new ResizeObserver(updateStickyFilterOffset);
    headerObserver.observe(stickyHeader);
    headerReadyObserver?.disconnect();
    updateStickyFilterOffset();
    return true;
  };

  const waitForStickyHeader = () => {
    if (initialiseStickyFilterOffset()) return;

    headerReadyObserver?.disconnect();
    headerReadyObserver = new MutationObserver(() => {
      initialiseStickyFilterOffset();
    });
    headerReadyObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForStickyHeader, { once: true });
  } else {
    waitForStickyHeader();
  }

  window.addEventListener('load', waitForStickyHeader, { once: true });
  window.addEventListener('resize', updateStickyFilterOffset, { passive: true });
  document.addEventListener('shopify:section:load', waitForStickyHeader);
})();
